.title {
  font-size: 17px;
  font-weight: bold;
  text-align: center;
}

.pressReleaseRoot {
  @container press-release-root (min-width: 1024px) {
    font-size: 19px;
    text-align: left;
  }
}

.screen {
  @media screen and (width >= 1024px) {
    font-size: 19px;
    text-align: left;
  }
}
